import { array, bool, func, number, oneOf, string } from 'prop-types'
import FilterBrowser from './FilterBrowser'
import FilterResults from './FilterResults'

import './styles.scss'

const SearchResults = ({
  currentPath,
  filterTree,
  highlightedFilterId,
  lastPath,
  loading,
  onFilterMouseMove,
  onFilterRemove,
  onFilterSelect,
  onPathChange,
  results,
  scrollToIndex,
  searchTerm,
  theme = 'light',
  value,
}) => {
  if (searchTerm) {
    const resultsProps = {
      highlightedFilterId,
      loading,
      onFilterMouseMove,
      onFilterRemove,
      onFilterSelect,
      results,
      scrollToIndex,
      theme,
      value,
    }
    return <FilterResults {...resultsProps} />
  }
  const browserProps = {
    currentPath,
    filterTree,
    highlightedFilterId,
    lastPath,
    loading,
    onFilterMouseMove,
    onFilterRemove,
    onFilterSelect,
    onPathChange,
    scrollToIndex,
    theme,
    value,
  }
  return <FilterBrowser {...browserProps} />
}
SearchResults.displayName = 'Kuiper: SearchResults ← FilterBar'

SearchResults.propTypes = {
  currentPath: array,
  filterTree: array,
  highlightedFilterId: string,
  lastPath: array,
  loading: bool,
  onFilterMouseMove: func,
  onFilterRemove: func,
  onFilterSelect: func,
  onPathChange: func,
  results: array,
  scrollToIndex: number,
  searchTerm: string,
  theme: oneOf(['dark', 'light']),
  value: array,
}

export default SearchResults
